// extracted by mini-css-extract-plugin
export default {"filters":"CompaniesScreen_filters__E67gU"};